import { BrokersBoundary } from "./boundary"
import CreateBroker from "./views/CreateBroker"
import ListBrokers from "./views/ListBrokers"
import Broker from "./views/SingleBroker"

export const VBrokersList: React.FC = (props) => (
  <BrokersBoundary>
    <ListBrokers {...props} />
  </BrokersBoundary>
)

export const VBroker: React.FC = (props) => (
  <BrokersBoundary>
    <Broker {...props} />
  </BrokersBoundary>
)

export const VBrokersCreate: React.FC = (props) => (
  <BrokersBoundary>
    <CreateBroker {...props} />
  </BrokersBoundary>
)
